export type Auth0Permissions = Auth0Permission[];

export enum Auth0Permission {
  ADMIN_DEV_TOOLS = 'admin:devTools',
  ADMIN_LAW = 'admin:law',
  ADMIN_USERS = 'admin:users',
  APP_EMPLOYEE = 'app:employee',
  APP_TESTER = 'app:tester',
}
